import { performSanityChecks, WidgetConfiguration, } from "./WidgetConfiguration";
export { WidgetConfiguration };
export function createWidgetConfiguration(widgetTag, options) {
    var config = new WidgetConfiguration(widgetTag, window.SGWTWidgetConfiguration, options);
    performSanityChecks(config, options);
    return config;
}
